<template> 
    <div class="content" :style="navbarWithName ? 'margin-left: 150px !important; margin-right: auto !important;' : ''"> <!--note: mt,mb,ml,mr(margin) jangan diubah-->
      
    <v-snackbar v-model="alertSuccess" :timeout="4000" top right color='primary' >
        <v-icon x-medium class="white--text">mdi-checkbox-marked-circle</v-icon>    <span>{{ alert_err_attention }}</span>
    </v-snackbar>
    <v-snackbar v-model="alertFailed" :timeout="4000" top right color='red' >
      <v-icon x-medium class="white--text">mdi-minus-circle</v-icon>   <span>{{ alert_err_attention }}</span>
    </v-snackbar>
    <v-breadcrumbs :items="page" class="ml-2 mt-0 pt-0"></v-breadcrumbs>
    
      <template >
        <v-toolbar flat > 
            <v-toolbar-title style="margin-left: 20px;"><v-icon class="mr-2">mdi-account-badge</v-icon> {{ this.$store.state.title }}</v-toolbar-title>
            <v-spacer></v-spacer>
              <v-flex lg3>
                <v-text-field class="pt-3 mr-4" v-model="search" append-icon="mdi-magnify" label="Search"></v-text-field>
              </v-flex>
        </v-toolbar> 
      </template>


<!--         
        <v-tabs
          v-model="tab"
          background-color="transparent"
          class="ml-6 mr-6"
        >
          <v-tab>
            User Daftar Company
          </v-tab>

          <v-tab>
            User Personal
          </v-tab>
        </v-tabs>
        <v-data-table 
        :headers="headers" 
        :items="usermanagement" 
        :search="search" 
        sort-by="username" 
        class="ml-6 mr-6 mt-4 rounded-lg"
        :loading="tableLoading"
        loading-text="Loading data..."
        >
          <template v-slot:top>
              <v-dialog v-model="dialogReject" width="330px"> 
                <v-card class="text-center align-center justify-center pa-6 rounded-lg" width="330px">
                  <v-avatar class="color-avatar3 my-4" size="62">
                    <v-icon x-large class="white--text">mdi-alert-octagon</v-icon>
                  </v-avatar> 
                  <div class="text-center text-h6 align-center justify-center font-weight-medium">
                    Confirm Reject
                  </div>
                  <v-card-text class="align-center justify-center mt-2">
                    Are you sure you want to reject, reject will permanently remove this item.
                  </v-card-text>
                  <v-divider class="mt-4" style=""></v-divider>
                  <v-card-actions class="align-center justify-center">
                    <v-btn rounded class="my-3 btn-ok" width="90px" dark @click="rejectItemConfirm">
                      OK
                    </v-btn>
                    <v-btn rounded outlined class="my-3" width="90px" color="red" dark @click="closeReject">
                      Cancel
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="dialogApproved" width="330px"> 
                <v-card class="text-center align-center justify-center pa-6 rounded-lg" width="330px">
                  <v-avatar class="color-avatar4 my-4" size="62">
                    <v-icon x-large class="white--text">mdi-alert-octagon</v-icon>
                  </v-avatar> 
                  <div class="text-center text-h6 align-center justify-center font-weight-medium">
                    Confirm Approve
                  </div>
                  <v-card-text class="align-center justify-center mt-2">
                    Are you sure you want to approve this item ?
                  </v-card-text>
                  <v-divider class="mt-4" style=""></v-divider>
                  <v-card-actions class="align-center justify-center">
                    <v-btn rounded class="my-3 btn-approve" width="90px" dark @click="approveItemConfirm">
                      Yes
                    </v-btn>
                    <v-btn rounded outlined class="my-3" width="90px" color="red" dark @click="closeApprove">
                      Cancel
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn color="success" small v-show="updateact" @click="approveItem(item.USER_ID)">
              Approve
            </v-btn>
            <v-btn color="dangers" small v-show=deleteact @click="rejectItem(item.USER_ID)">
              Reject
            </v-btn>
          </template>
          <template v-slot:no-data>
            <v-btn color="primary" @click="initialize">
              Reset
            </v-btn>
          </template>
        </v-data-table> -->
        <v-tabs
          v-model="tab"
          background-color="transparent"
          class="ml-6 mr-6"
        >
          <v-tab>
            User Daftar Company
          </v-tab>

          <v-tab>
            User Personal
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">

          <!-- TAB COMPANY -->
          <v-tab-item>
            <v-data-table
              :headers="headersCompany"
              :items="userCompany"
              :search="search"
              sort-by="USERNAME"
              class="ml-6 mr-6 mt-4 rounded-lg"
              :loading="tableLoading"
              loading-text="Loading data..."
            >

              <template v-slot:[`item.actions`]="{ item }">
                <v-btn
                  color="success"
                  small
                  v-show="updateact"
                  @click="approveItem(item.USER_ID)"
                >
                  Approve
                </v-btn>

                <v-btn
                  color="danger"
                  small
                  v-show="deleteact"
                  @click="rejectItem(item.USER_ID)"
                >
                  Reject
                </v-btn>
              </template>

            </v-data-table>
          </v-tab-item>

          <!-- TAB PERSONAL -->
          <v-tab-item>
            <v-data-table
              :headers="headersPersonal"
              :items="userPersonal"
              :search="search"
              sort-by="USERNAME"
              class="ml-6 mr-6 mt-4 rounded-lg"
              :loading="tableLoading"
              loading-text="Loading data..."
            >

              <template v-slot:[`item.actions`]="{ item }">
                <v-btn
                  color="success"
                  small
                  v-show="updateact"
                  @click="approveItem(item.USER_ID)"
                >
                  Approve
                </v-btn>

                <v-btn
                  color="danger"
                  small
                  v-show="deleteact"
                  @click="rejectItem(item.USER_ID)"
                >
                  Reject
                </v-btn>
              </template>

            </v-data-table>
          </v-tab-item>

        </v-tabs-items>
      <Notification  ref="alert"></Notification>
    </div>
  </template>
  <script>
  import Notification from  '@/components/Notification';
  import { decryptionData } from '@/components/utils/utils.js';
  import axios from "axios";
  import { mapGetters } from 'vuex';
    export default {
      components: {
        Notification: Notification
      },
      data: () => ({
        btnload:false,
        alertSuccess:'',
        alertFailed:'',
        alert_err_attention: "",
  
        deleteact: false,
        insertact: false,
        updateact: false,
        viewact: false,
       
        dialogApproved: false,
        dialogReject: false,
        first_login: 'Y',
        pushchangepassword: [//choice select
            {valuechangepassword: 'Y', name_changepassword: "Yes" },
            {valuechangepassword: 'N', name_changepassword: "No" }
          ],
        is_blok:'Y',
        blockstatus: [//choice select
            {valueblockstatus: 'Y', name_blockstatus: "Yes" },
            {valueblockstatus: 'N', name_blockstatus: "No" }
          ],
          
        loginstatusinput:'Y',
        loginstatus: [//choice select
            {valueloginstatus: 'Y', name_loginstatus: "Yes" },
            {valueloginstatus: 'N', name_loginstatus: "No" }
          ],
          
        showpassword: false,
        password: 'Password',
        group_id: '',
        grouprole: [//choice select
          {
            valuegrouprole: '', 
            name_grouprole: '' 
          }
        ],
        
        rolename: ['ADMIN', 'USER', 'REVIEWER'],
        search:'',
        headers: [
          { text: 'Username', value: 'USERNAME' },
          { text: 'E-mail', value: 'EMAIL' },
          { text: 'Created Date', value: 'CREATED_DATE' },
          { text: 'Group', value: 'GROUP_NAME' },
          { text: 'Actions', value: 'actions', width: '200px', sortable: false },
        ],

        // HEADER TAB COMPANY
        headersCompany: [
          { text: 'Username', value: 'USERNAME' },
          { text: 'E-mail', value: 'EMAIL' },
          { text: 'Created Date', value: 'CREATED_DATE' },
          { text: 'Group', value: 'GROUP_NAME' },
          { text: 'Actions', value: 'actions', width: '200px', sortable: false },
        ],

        // HEADER TAB PERSONAL
        headersPersonal: [
          { text: 'Username', value: 'USERNAME' },
          { text: 'Full Name', value: 'FULLNAME' },
          { text: 'Phone', value: 'MOBILE' },
          { text: 'Created Date', value: 'CREATED_AT' },
          { text: 'Actions', value: 'actions', width: '200px', sortable: false },
        ],
        tab: 0,
        usermanagement: [],
        userCompany: [],
        userPersonal: [],
        id_user_management:'',
        username_old:'',
        salt:'',
        editedIndex: -1,
        inputitem: {
        },
        defaultItem: {
          username: '',
          fullname: '',
          email: '',
          mobile: '',
          createdate: '',
          lastlogin: '',
          lastactivity: '',
          lastmodule: '',
          islogin: '',
          isblock: '',
          group: '',
        },
      }),
      computed: {

        page() {
          return this.$store.state.breadcrumbs
        },
        ...mapGetters(['navbarWithName']), // Accessing navbarWithName from Vuex
        formTitle () {
          return this.editedIndex === -1 ? 'Data User' : 'Update User'
        },
      },
      watch: {
        dialogApproved (val) {
          val || this.closeApprove()
        },
        dialogReject (val) {
          val || this.closeReject()
        },
      },
      created () {
        this.initialize()
      },
      props: ['userId'], 
      mounted() {
        console.log('User ID:', this.userId);  // Cek apakah userId diterima dengan benar
      },
      methods: {
        async initialize () {
          this.tableLoading = true;
          this.usermanagement = [];
          axios.get("users-register",
            { headers:{'auth-token':localStorage.getItem('token_app')}},
            {dataType: 'json'}
            ).then((response) => {
              let res = decryptionData(response.data.token);
              var propuserId = this.userId;
              if(propuserId  != undefined){
                // this.usermanagement = res.result.filter(item => item.USER_ID === Number(this.userId));
                this.userCompany = res.user_company.filter(item => item.USER_ID === Number(this.userId));
                this.userPersonal = res.user_personal.filter(item => item.SEQ_ID === Number(this.userId));

                
                // console.log(this.usermanagement)
                this.deleteact = true 
                this.insertact = true 
                this.updateact = true 
                this.viewact = true 
              }else{

                // this.usermanagement = res.result;
                this.userCompany = res.user_company;
                this.userPersonal = res.user_personal;
                if(localStorage.getItem('authactdeletedt') == 1){ this.deleteact = true }
                if(localStorage.getItem('authactinsert') == 1){ this.insertact = true }
                if(localStorage.getItem('authactupdate') == 1){ this.updateact = true }
                if(localStorage.getItem('authactview') == 1){ this.viewact = true }
              }

              this.tableLoading = false;
              setTimeout(() =>{
                this.loading = false
              // end loading 
              },1000)

            })
            .catch((e) => {
                switch (e.response.status) {
                      case 404:
                            this.$refs.alert.error_login(404);
                          break;
                      case 403:
                            this.$refs.alert.error_login(403);
                          break;
                      default:
                          console.log('some other error');  // end up here all the time
                          break;
                    }
              this.tableLoading = false;
  
            this.errors=e.response.data.msg;
          });
        },
        // end select 
        rejectItem (item) {
          this.id_user_management = item
          this.editedIndex = this.usermanagement.indexOf(item)
          this.inputitem = Object.assign({}, item)
          this.dialogReject = true
        },
        rejectItemConfirm () {
          this.usermanagement.splice(this.editedIndex, 1)
          axios({
            method: "delete",
            url: "/reject-user-registrasi",
            data: {
              id: this.id_user_management
            },
            headers:{'auth-token':localStorage.getItem('token_app')},
            dataType: 'json'
          })
          .then((response) => {
            // handle success
                var status = response.data.status
                var messages = response.data.msg
                if(status == 200){
                  this.alertSuccess = true;
                  this.alert_err_attention =  messages;
                  this.closeReject()
                }else{
                    this.alertFailed = true;
                    this.alert_err_attention =  messages;
                    this.closeReject()
                } 
                this.initialize();
          })
          .catch(function (error) {
            // handle error
                this.alertFailed = true;
                this.alert_err_attention =  'Delete Failed '+error;
                this.closeReject()
          })
          this.closeReject()
        },
        closeReject () {
          this.dialogReject = false
          this.$nextTick(() => {
            this.inputitem = Object.assign({}, this.defaultItem)
            this.editedIndex = -1
          })
        },
        // end select 
        approveItem (item) {
          this.id_user_management = item
          this.editedIndex = this.usermanagement.indexOf(item)
          this.inputitem = Object.assign({}, item)
          this.dialogApproved = true
        },
        approveItemConfirm () {
          this.usermanagement.splice(this.editedIndex, 1)
          axios({
            method: "put",
            url: "/approve-user-registrasi",
            data: {
              id: this.id_user_management
            },
            headers:{'auth-token':localStorage.getItem('token_app')},
            dataType: 'json'
          })
          .then((response) => {
            // handle success
                var status = response.data.status
                var messages = response.data.msg
                if(status == 200){
                  this.alertSuccess = true;
                  this.alert_err_attention =  messages;
                  this.closeApprove()
                }else{
                    this.alertFailed = true;
                    this.alert_err_attention =  messages;
                    this.closeApprove()
                } 
                this.initialize();
          })
          .catch(function (error) {
            // handle error
                this.alertFailed = true;
                this.alert_err_attention =  'Delete Failed '+error;
                this.closeApprove()
          })
          this.closeApprove()
        },
        closeApprove () {
          this.dialogApproved = false
          this.$nextTick(() => {
            this.inputitem = Object.assign({}, this.defaultItem)
            this.editedIndex = -1
          })
        },
        
      },
    }
  </script>
  
  
  <style scoped>
  .btn-ok{
    background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
  }
  .v-avatar.color-avatar3
  {
    box-shadow: 0 5px 15px rgba(255, 0, 0, 0.4);
    background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
  }
  
  .btn-approve{
    background-image: linear-gradient(to bottom, #3f3fef, #4040d0, #4040d0, #4040d0, #4040d0, #4040d0, #4040d0, #4040d0, #4040d0, #4040d0, #4040d0, #4040d0);
  }
  .v-avatar.color-avatar4
  {
    box-shadow: 0 5px 15px rgba(8, 112, 231, 0.4);
    background-image: linear-gradient(to bottom, #3f3fef, #3f3fef, #3f3fef, #3f3fef, #3f3fef, #3f3fef, #3f3fef, #3f3fef, #3f3fef, #3f3fef, #3f3fef, #3f3fef);
  }
  </style>